import React from 'react';
import ChoroplethSvg from '@splunk/dashboard-visualizations/ChoroplethSvg';
import { campusSvgDataURI } from '../../mockdata/campusSvgDataURI.js';

const baseProps = {
    width: 700,
    height: 500,
    options: {
        svg: campusSvgDataURI,
    },
};

export default () => <ChoroplethSvg {...baseProps} />;
